import { IonButton, IonDatetime, IonItem, IonLoading, IonText, IonModal, IonSelect } from "@ionic/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setInitialData } from "../../../store/attendance";
import { getReport } from "../../../store/attendance/actions/getReport";
import { RootState } from "../../../store/rootReducer";
import { monthsOfTheYear, getMonthAndYear } from "../utils";
import OrganizationSelector from "./OrganizationSelector";

export const ReportSelector = () => {
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [showOrgSelector, setShowOrgSelector] = useState(false);
  const dispatch = useDispatch();
  const maxDate = new Date();
  const reportUrl = useSelector((state: RootState) => state.attendance.reportUrl);
  const syncDetails = useSelector((state: RootState) => state.attendance.reportSync);
  const getReportStatus = useSelector((state: RootState) => state.attendance.getReportStatus);
  const userIdObject = useSelector((state: RootState) => state.userAuthentication.user?.id);
  const userId = Number(userIdObject);


  const handleGetApprovedReport = () => {
    setShowOrgSelector(true); // Mostrar el selector de organización
  };

  const handleOrganizationSelect = (orgId: string) => {
    setShowOrgSelector(false); // Cerrar el modal
    const { month, year } = getMonthAndYear(selectedDate);
    dispatch(getReport({ month, year, organization: orgId })); // Solicitar el informe con la organización seleccionada
  };

  const handleDownloadFile = () => {
    const link = document.createElement("a");
    link.href = reportUrl;
    link.setAttribute("download", "informe-asistencia.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    dispatch(setInitialData());
  };


  return (
    <>
      <IonText class="ion-text-center">
        <h4>Información preliminar disponible a la fecha</h4>
      </IonText>

      <IonItem>
        <IonDatetime
          displayFormat="MMMM/YYYY"
          placeholder="Seleccionar mes"
          monthNames={monthsOfTheYear}
          value={selectedDate}
          max={maxDate.toISOString()}
          min="2022-06"
          cancelText="Cancelar"
          doneText="Confirmar"
          onIonChange={(e) => setSelectedDate(e.detail.value || "")}
        />
      </IonItem>
      <br />
      <IonButton
        disabled={selectedDate.length === 0}
        expand="block"
        onClick={handleGetApprovedReport}
      >
        Solicitar informe preliminar
      </IonButton>
      {!syncDetails.status && (
        <div style={{ color: "red", fontWeight: "bold" }}>
          <h4>Recuerde que debe sincronizar primero antes de sacar el informe</h4>
        </div>
      )}
      <br />
      <span>Información disponible al cierre del pago de las imposiciones de los trabajadores</span>

      <IonLoading
        isOpen={getReportStatus === "pending"}
        message={"Descargando documento..."}
        onDidDismiss={handleDownloadFile}
      />

      <IonModal isOpen={showOrgSelector} onDidDismiss={() => setShowOrgSelector(false)}>
        {userId !== undefined && (
          <OrganizationSelector
            onChange={handleOrganizationSelect}
            interfaceOptions={{ cssClass: 'custom-org-alert' }}
          />
        )}
      </IonModal>
    </>
  );
};
